import { useWebViewStore } from '#ui-shared/stores/webview/webview-store';
import { NoraWebViewEventPattern } from '#ui-shared/stores/webview/webview.types';

import type { SseHandlers, SseSource } from './sse-source';

export class WebViewSseSource implements SseSource {
  private started = false;
  private handlers?: SseHandlers;

  constructor() {
    this.setupListener();
  }

  start(handlers: SseHandlers): void {
    if (this.started) {
      return;
    }

    this.handlers = handlers;
    this.started = true;

    this.handlers?.onopen?.();
  }

  stop(): void {
    this.started = false;
    this.handlers = undefined;
  }

  private setupListener(): void {
    const webViewStore = useWebViewStore();

    webViewStore.addNativeLayerEventListener(
      NoraWebViewEventPattern.SSE_STREAM_EVENT,
      (event: CustomEvent<{ data: { pattern: string } & Record<string, unknown> }>) => {
        if (!this.started) {
          return;
        }

        console.debug('[WebViewSseSource] Received SSE event:', JSON.stringify({
          pattern: event.detail.data.pattern,
          data: event.detail.data,
          timestamp: new Date().toISOString(),
        }));

        this.handlers?.onmessage(JSON.stringify(event.detail.data));
      },
    );
  }
}
